import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import DistributorsEditCard from '../components/distributors/DistributorsEditCard'
import apiDistributorService from '../services/apiDistributorService'
import '../styles/FormView.css'

function DistributorsEditView() {
  const navigate = useNavigate()
  const location = useLocation()
  const [distributor, setDistributor] = useState(null)
  const [formData, setFormData] = useState({ name: '' })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (location.state?.distributor) {
      const current = location.state.distributor
      setDistributor(current)
      setFormData({ name: current.name || '' })
    } else {
      navigate('/distributors')
    }
  }, [location, navigate])

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es requerido'
    }
    return newErrors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    if (!distributor?.id) {
      setMessage('No hay distribuidor seleccionado.')
      return
    }

    setIsSaving(true)
    try {
      await apiDistributorService.updateDistributor(distributor.id, { name: formData.name })
      navigate('/distributors')
    } catch (error) {
      const messageText = error?.body?.message || 'No se pudo actualizar el distribuidor.'
      setMessage(messageText)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Distribuidores</h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <DistributorsEditCard
                distributor={distributor}
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                message={message}
                onInputChange={handleInputChange}
                onSubmit={handleSubmit}
                onCancel={() => navigate('/distributors')}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default DistributorsEditView
